import { CSSProperties } from "react";
import { Form, Typography } from "antd";
import { rgba, cssVar } from "polished";
import styled from "styled-components";
import theme from "styles/theme";
const { Item } = Form;
const { Title } = Typography;

const colorsHelper = () => {
  const defaultValue = "#fff";
  return {
    "--color-brand-100": cssVar("--color-brand-100", defaultValue),
    "--color-neutral-600": cssVar("--color-neutral-600", defaultValue),
    "--color-neutral-200": cssVar("--color-neutral-200", defaultValue),
    "--opacity-level-5": cssVar("--opacity-level-5", defaultValue),
    "--opacity-level-2": cssVar("--opacity-level-2", defaultValue),
  };
};

export const LocationsTitle: CSSProperties = {
  fontWeight: "lighter",
  fontFamily: theme["@font-family"],
};

export const FormItem = styled(Item)`
  .ant-input {
    margin-left: 0;
  }

  .ant-form-item-explain-error {
    color: ${(props) => props.theme["@danger-color"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
  }

  .ant-input-affix-wrapper {
    border: 1.6px solid ${(props) => props.theme.colors.manatee};
    :hover {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-input-affix-wrapper.ant-input-affix-wrapper-status-success {
    :hover {
      background: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    }
    .ant-input {
      :hover {
        background: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
      }
    }
  }

  .ant-input-affix-wrapper-status-success:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper,
  .ant-input-affix-wrapper-status-success:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper:hover {
    background: ${(props) => props.theme["@secondary-color"]};
    .ant-input {
      :hover {
        background-color: ${(props) => props.theme["@secondary-color"]};
      }
    }
  }

  .ant-input-affix-wrapper.ant-input-affix-wrapper-status-success {
    :hover {
      background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
    }
    .ant-input {
      :hover {
        background-color: ${() => rgba(colorsHelper()["--color-brand-100"], Number(colorsHelper()["--opacity-level-5"]))} !important;
      }
    }
  }

  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper.ant-input-affix-wrapper-focused.ant-input-affix-wrapper-status-error,
  .ant-input-affix-wrapper-focused {
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    outline: 1.6px solid ${(props) => props.theme.colors.text};
    box-shadow: none;
    outline-offset: 1.6px;
    background-color: ${(props) => props.theme["@secondary-color"]};
  }

  .ant-form-item {
    max-width: 100% !important;
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-label > label {
    font-size: ${(props) => props.theme["@medium-font-size"]} !important;
    pointer-events: none !important;
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional):before {
    margin-right: 0;
  }

  .ant-input-clear-icon {
    color: ${() => rgba(colorsHelper()["--color-neutral-600"], Number(colorsHelper()["--opacity-level-2"]))};
    font-size: ${(props) => props.theme["@large-font-size"]};
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    height: ${(props) => props.theme["@height-input-lg"]};
  }

  .ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 48px;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector:hover {
    background-color: ${(props) => props.theme["@primary-color"]};
  }
`;

export const MultiLocations = styled.div`
  margin: 10px 0 5px 0;
  > label > span:nth-child(2) {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }
`;

export const LocationsContainer = styled.div`
  width: 100%;
  margin-bottom: 35px;
  height: ${(props) => props.theme["@height-input-lg"]} !important;
  .ant-select-multiple .ant-select-selector {
    width: 100%;
    color: ${(props) => props.theme.colors.text};
    font-family: ${(props) => props.theme["@font-family"]};
    height: 48px;
    padding: 0 11px;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
  }
  .ant-select.ant-select-in-form-item.ant-select-focused {
    > div {
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: ${() => rgba(colorsHelper()["--color-neutral-200"], Number(colorsHelper()["--opacity-level-1"]))} !important;
    color: ${(props) => props.theme.text} !important;
    :hover {
      background-color: ${() => rgba(colorsHelper()["--color-neutral-200"], Number(colorsHelper()["--opacity-level-1"]))} !important;
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
    }
  }
  .ant-select-disabled.ant-select-multiple .ant-select-selection-item {
    color: ${(props) => props.theme.colors.text} !important;
    background-color: #ebebeb !important;
    border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
    border-radius: 17px !important;
    :hover {
      background-color: #ebebeb !important;
      border: 1.6px solid ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-select-multiple .ant-select-selection-item {
    border-radius: 17px !important;
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
    background-color: ${(props) => props.theme["@secondary-color"]} !important;
    :hover {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: 1.6px solid ${(props) => props.theme["@hover-input-background-color"]} !important;
    }
  }
`;

export const DescriptionUser = styled(Title)`
  font-family: ${(props) => props.theme["@font-family"]} !important;
  font-weight: ${(props) => props.theme["@normal-font-weight"]} !important;
  font-size: ${(props) => props.theme["@medium-font-size"]} !important;
`;

export const DescriptionField: CSSProperties = {
  width: "100%",
  fontWeight: theme["@bold-font-weight"],
  fontSize: theme["@medium-font-size"],
};

export const DescriptionFormItem: CSSProperties = {
  width: "100%",
  fontWeight: theme["@bold-font-weight"],
  fontSize: theme["@medium-font-size"],
};

export const SelectField: CSSProperties = {
  color: theme["@default-color"],
  fontFamily: theme["@font-family"],
  height: theme["@height-input-lg"],
};

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const InputJobTitle: CSSProperties = {
  height: theme["@height-input-lg"],
  border: `1px solid ${theme.colors.manatee}`,
  borderRadius: theme["@border-radius-base"],
  fontSize: theme["@medium-font-size"],
};

export const LayoutForm = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;

  .ant-form-item {
    max-width: 100%;
    margin: 0;
  }
  .ant-divider-horizontal {
    margin-top: 40px;
  }

  .ant-btn-default {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: 1px solid ${(props) => props.theme.colors.text} !important;
    height: 48px !important;
    :hover,
    :focus {
      background-color: ${(props) => props.theme["@hover-input-background-color"]} !important;
      border: none !important;
      color: ${(props) => props.theme["@default-color"]};
    }
  }

  .ant-btn-primary {
    color: ${(props) => props.theme["@default-color"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    border: none;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-color"]};
      background-color: ${(props) => props.theme["@hover-input-background-color"]};
      border: none;
    }
  }

  .ant-btn.ant-btn-default {
    height: 48px !important;
    color: ${(props) => props.theme["@default-color"]};
  }

  .ant-btn.ant-btn-primary {
    height: 48px !important;
    color: ${(props) => props.theme["@default-color"]};
  }
`;

export const UserInfo = styled.div`
  max-height: 500px;
  max-width: 50%;
  width: 100%;
  gap: 0 20px;
  display: grid;
  grid-template-areas:
    "name name"
    "email email"
    "status status"
    "checkbox-locations checkbox-locations"
    "role location"
    "jobTitle language"
    "locations locations";
  grid-template-columns: 1fr 1fr;

  .name {
    grid-area: name;
  }
  .email {
    grid-area: email;
  }
  .status {
    grid-area: status;
  }
  .checkbox-locations {
    grid-area: checkbox-locations;
  }
  .role {
    grid-area: role;
  }
  .location {
    grid-area: location;
  }
  .jobTitle {
    grid-area: jobTitle;
  }
  .locations {
    grid-area: locations;
  }
  .language {
    grid-area: language;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    grid-auto-flow: row;
    max-width: 100%;

    & > :nth-child(1) {
      grid-column: 1;
      grid-row: 1;
    }
    & > :nth-child(2) {
      grid-column: 2;
      grid-row: 1;
    }
    & > :nth-child(3) {
      grid-column: 1 / -1;
      grid-row: 2;
    }
    & > :nth-child(4) {
      grid-column: 1 / -1;
      grid-row: 3;
    }
    & > :nth-child(5) {
      grid-column: 1;
      grid-row: 4;
    }
    & > :nth-child(6) {
      grid-column: 2;
      grid-row: 4;
    }
    & > :nth-child(7) {
      grid-column: 1;
      grid-row: 5;
    }
    & > :nth-child(8) {
      grid-column: 2;
      grid-row: 5;
    }
    & > :nth-child(9) {
      grid-column: 1 / -1;
      grid-row: 6;
    }
  }
`;

export const BtnDataTestid = {
  display: "none",
};
